import { Modal, ModalBody, ModalHeader } from "reactstrap";

type AppProps = {
  showAllEmailersModal: boolean;
  toggleViewAllEmailersModal: () => void;
  singleEmailerInfo: any;
};

const ShowAllEmailersModal = ({
  showAllEmailersModal,
  toggleViewAllEmailersModal,
  singleEmailerInfo,
}: AppProps) => {
  let finalName=singleEmailerInfo?.client_name
  ? `${singleEmailerInfo.client_name}${singleEmailerInfo.client_code ? ` (${singleEmailerInfo.client_code})` : ""}`
  : singleEmailerInfo?.client_code
  ? `${singleEmailerInfo.client_code}`
  : ""
  return (
    <Modal
      isOpen={showAllEmailersModal}
      toggle={toggleViewAllEmailersModal}
      modalClassName="custom-modal-width"
        backdrop="static"
    >
      <ModalHeader className="pt-4 pl-4"  toggle={toggleViewAllEmailersModal}>Emailer Templates Assigned</ModalHeader>
      <ModalBody className="pl-4 pr-4"  style={{overflowY: 'auto', height:'395px'}}  >
        <>
          <div className="upperDivEmailer">
            <div>
              <label className="emailerLabel">Username</label>
              <div className="emailerValues">{singleEmailerInfo?.name}</div>
            </div>
            <div>
              <label className="emailerLabel">User Contact Details</label>
              <div className="emailerValues">{singleEmailerInfo?.email_id}</div>
              <div className="emailerValues">{singleEmailerInfo?.mobile}</div>

            </div>
            <div>
              <label className="emailerLabel">Client Name and Code</label>
             
              <div className="emailerValues">
              
                    {finalName?finalName:"--/--"}
                    </div>
            </div>
           
          </div>
          <div>
            <div className="emailerTemplateHeading">Emailer Templates Assigned as below</div>
            <div className="emailerTotalCount">
              Total {singleEmailerInfo?.emailer_settings?.length} templates
              found
            </div>
          </div>
          <div>
            {/* <ul> */}
              {singleEmailerInfo?.emailer_settings?.map((element: any) => {
                return (
                  <>
                    <div style={{marginBottom:'14px'}}>
                        <span className="blueColorBatch">  {element}</span>
                      
                        </div>
                  </>
                );
              })}
            {/* </ul> */}
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default ShowAllEmailersModal;
